import React, { useState } from 'react';
import axios from 'axios';
import { Modal, message } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import '../styles/DemandeInscription.css';

const DemandeInscription = () => {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    telephone: '',
    email: '',
  });

  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'http://localhost:8080/anonymes/demandeInscription',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      if (response.status === 200) {
        setModalVisible(true);
        setFormData({ nom: '', prenom: '', telephone: '', email: '' });

        setTimeout(() => {
        window.location.reload();
      }, 600);

      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        message.error(error.response.data.message || "Demande invalide. Vérifiez vos champs.");
      } else if (error.response && error.response.status === 409) {
        message.warning("Cette adresse e-mail ou ce téléphone est déjà utilisé.");
      } else {
        message.error("Une erreur technique est survenue. Veuillez réessayer plus tard.");
      }
    }
  };

  return (
    <section className="demande-section" id="demande">
      <div className="demande-container">
        <div className="demande-form-wrapper">
          <h2>Inscription influenceur</h2>
          <form className="demande-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nom">Nom</label>
              <input
                type="text"
                id="nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
                placeholder="Votre nom"
              />
            </div>

            <div className="form-group">
              <label htmlFor="prenom">Prénom</label>
              <input
                type="text"
                id="prenom"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
                required
                placeholder="Votre prénom"
              />
            </div>

            <div className="form-group">
              <label htmlFor="telephone">Téléphone</label>
              <input
                type="tel"
                id="telephone"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                required
                placeholder="Ex : +223 70 00 00 00"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Adresse mail</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="votre-email@mail.com"
              />
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Envoi en cours..." : "Envoyer la demande"}
            </button>
          </form>
        </div>

        <div className="demande-info">
          <h3>Pourquoi devenir influenceur chez nous ?</h3>
          <p>
            Rejoignez notre communauté dynamique d’influenceurs et bénéficiez de primes attractives pour chaque inscription validée.
            Partagez votre lien unique, développez votre réseau, et profitez d’une expérience motivante et enrichissante !
          </p>
        </div>
      </div>

      {/* Modal de confirmation */}
      <Modal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        centered
        className="confirmation-modal"
      >
        <div className="modal-content">
          <CheckCircleFilled style={{ fontSize: '3rem', color: '#52c41a' }} />
          <h2 className="modal-title">Demande envoyée avec succès</h2>
          <p>
            Merci <strong>{formData.prenom}</strong> ! Votre demande a bien été envoyée.
            <br />
            Vous recevrez un email dès que votre compte sera validé par l’équipe ISPATEC.
          </p>
        </div>
      </Modal>
    </section>
  );
};

export default DemandeInscription;
